import EmailTemplateCreate from "@/modules/templates/views/EmailTemplateCreate"
import EmailTemplateUpdate from "@/modules/templates/views/EmailTemplateUpdate"

import TemplatesList from "@/modules/templates/views/TemplatesList"
import TemplateAssets from "@/modules/templates/views/TemplateAssets"
import PdfTemplatesCreate from "@/modules/templates/views/PdfTemplatesCreate"
import PdfTemplatesUpdate from "@/modules/templates/views/PdfTemplatesUpdate"
import DynamicTemplateUpdate from "@/modules/templates/views/DynamicTemplateUpdate"
import FunctionTemplateUpdate from "@/modules/templates/views/FunctionTemplateUpdate"
import NotificationTemplatesUpdate from "@/modules/templates/views/NotificationTemplatesUpdate"

export default [
	{
		path: "/:tenantId/templates/create/email",
		name: "EmailTemplateCreate",
		component: EmailTemplateCreate,
		meta: { featureId: "templates" },
		props: true
	},
	{
		path: "/:tenantId/templates/update/email/:id",
		name: "EmailTemplateUpdate",
		component: EmailTemplateUpdate,
		meta: { featureId: "templates" },
		props: true
	},

	{
		path: "/:tenantId/templates/create/pdf",
		name: "PdfTemplatesCreate",
		component: PdfTemplatesCreate,
		props: true,
		meta: { featureId: "templates" }
	},

	{
		path: "/:tenantId/templates",
		component: TemplatesList,
		name: "TemplatesList",
		meta: { featureId: "templates" }
	},
	{
		path: "/:tenantId/templates/assets",
		component: TemplateAssets,
		name: "TemplateAssets",
		meta: { featureId: "templates" }
	},

	{
		path: "/:tenantId/templates/update/pdf/:id",
		component: PdfTemplatesUpdate,
		name: "PdfTemplatesUpdate",
		props: true,
		meta: { featureId: "templates" }
	},
	{
		path: "/:tenantId/templates/update/dynamic/:id",
		component: DynamicTemplateUpdate,
		name: "DynamicTemplateUpdate",
		props: true,
		meta: { featureId: "templates" }
	},
	{
		path: "/:tenantId/templates/update/function/:id",
		component: FunctionTemplateUpdate,
		name: "FunctionTemplateUpdate",
		props: true,
		meta: { featureId: "templates" }
	},
	{
		path: "/:tenantId/templates/update/notification/:id",
		component: NotificationTemplatesUpdate,
		name: "NotificationTemplatesUpdate",
		props: true,
		meta: { featureId: "templates" }
	}
]
